import BaseViewController from "./base-view-controller";
import extractFieldValues from "../utils/extract-field-values";
import { getFlow } from "../api/flow";

class AccountCareRecipientsNewViewController extends BaseViewController {
  preprocessScreenData() {
    if (this.appData.lastNavAction === "next") {
      if (this.appData.careRecipientStored) {
        const values = extractFieldValues(this.screen, {});
        this.appData.values = {
          ...this.appData.values,
          ...values
        };

        this.appData.resetCareRecipient();
      }
    }
  }

  handleButtonClick(name, text, action) {
    if (this.screen.type !== "modal_screen") {
      this.appData.setFlowStatusLoading();
      return getFlow({
        url: action.value,
        formState: this.prepareSubmit(this.appData.values)
      }).then(() => this.appData.prevScreen());
    }
    super.handleButtonClick(name, text, action);
  }
}
export default AccountCareRecipientsNewViewController;
